export const formatFullWidthPunctuation = (text?: string | null): string => {
  if (!text) {
    return '';
  }
  return text.replace(/,/g, '，').replace(/\./g, '。');
};
